/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import Dish from '@/model/dish/Dish'
import hillo from 'hillo'
import { showSuccessMessage } from '@/common/utils'
// import PfandDish from '@/model/PfandDish'

const entity = {
  id: {
    form: false,
    type: IKDataEntity.Types.Integer,
    tableConfig: {},
  },
  dishName: {
    form: false,
    displayName: 'name',
  },

  pfandId: {
    displayName: 'pfandName',
    header: false,
  },

  pfandName: {
    form: false,
  },

}

const config = {

  load: async function () {
    // await reload()
    const allDishes = await Dish.getList()

    // 获得所有押金的商品名称
    const pfandList = allDishes.filter(i => ['-19', '-20'].indexOf(i.categoryId.toString()) >= 0).map(item => {
      return {
        id: item.id,
        pfandName: item.dishName,
      }
    })

    // 获得所有商品和押金的关系
    const dishPfandCombination = Object.entries((await hillo.get('Dishes.php?op=showCombinations')).content)
      .map(item => {
        return {
          id: item[0],
          pfandId: item[1],
        }
      })

    // console.log('Dies', dishPfandCombination)
    // console.log('pfandList', pfandList)

    // 对商品数据进行进一步加工和处理
    allDishes.map(item => {
      const comb = dishPfandCombination.find(i => i.id.toString() === item.id.toString())
      // console.log('comb', comb)
      if (comb) {
        item.pfandId = comb.pfandId[0]
        item.pfandName = pfandList.find(j => j.id.toString() === comb.pfandId[0])?.pfandName
      }

      return item
    })
    // console.log(allDishes.find(i => i.id.toString() === '666'))
    return allDishes
  },

}

export const getPfandList = async function () {
  const allDishes = await Dish.getList()
  const pfandList = allDishes.filter(i => ['-19', '-20'].indexOf(i.categoryId.toString()) >= 0).map(item => {
    return {
      id: item.id,
      pfandName: item.dishName,
    }
  })

  return pfandList
}

export function reload () {
  config.load().then(() => {
    showSuccessMessage('Success')
  })
}

export default IKDataEntity.ModelFactory(entity, config)
